<template>
    <ul class="main-board">
        <li class="py-10" v-if="!items.length">
            <p class="page-text font-weight-bold text-center">
                게시글이 없습니다.
            </p>
        </li>
        <li v-for="{ _id, subject, createdAt } in items" :key="_id">
            <router-link :to="`/community/reference/${_id}`" class="w-100">
                <p class="main-board__category font-weight-bold mb-2 mb-md-0">KEA</p>
                <p class="main-board__tit text-left ellip mb-6 mb-md-0">{{ subject }}</p>
                <p class="main-board__date">{{ createdAt.toDate() }}</p>
            </router-link>
        </li>
    </ul>
    <!-- <div class="main-board">
        <ul>
            <li v-if="!items.length">
                <div class="main-board__con">
                    <small class="main-board__tit2" style="opacity:0">KEA</small>
                    <h3 class="main-board__tit">게시글이 없습니다.</h3>
                    <div class="main-board__date" style="opacity:0">2021.12.12</div>
                </div>
                <div class="main-board__btn-wrap"></div>
            </li>
            <li v-for="{ _id, subject, createdAt } in items" :key="_id">
                <div class="main-board__con">
                    <small class="main-board__tit2">KEA</small>
                    <h3 class="main-board__tit">{{ subject }}</h3>
                    <div class="main-board__date">{{ createdAt.toDate() }}</div>
                </div>
                <div class="main-board__btn-wrap">
                    <router-link :to="`/community/reference/${_id}`" class="main-board__btn">자세히 보기</router-link>
                </div>
            </li>
        </ul>
    </div> -->
</template>

<script>
import api from "@/api";
export default {
    computed: {
        items() {
            return [...(this.fixed || []), ...(this.boards || [])];
        },
    },
    data() {
        return {
            limit: 5,
            fixed: [],
            boards: [],
        };
    },
    methods: {
        async search() {
            try {
                let { limit } = this;
                var { boards: fixed } = await api.v1.boards.gets({
                    headers: { limit },
                    params: { isNotice: true, code: "yfactory-reference" },
                });
                this.fixed = fixed;

                limit -= fixed.length;
                if (limit) {
                    var { boards } = await api.v1.boards.gets({
                        headers: { limit },
                        params: { isNotice: false, code: "yfactory-reference" },
                    });

                    this.boards = boards;
                }
            } catch (error) {
                this.handleError(error);
            }
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
